/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RoleGrant,
  RoleGrant$Outbound,
  RoleGrant$outboundSchema,
} from "./rolegrant.js";

export type UpdateRoleForm = {
  /**
   * Scope grants to add.
   */
  addGrants?: Array<RoleGrant> | undefined;
  /**
   * The complete set of agent IDs assigned to this role. Unlike member_ids this replaces the role's agent membership, because agents have no other surface to be removed from a role on. Omit to leave agent membership untouched.
   */
  agentIds?: Array<string> | undefined;
  /**
   * Updated description.
   */
  description?: string | undefined;
  /**
   * The ID of the role to update.
   */
  id: string;
  /**
   * Optional member IDs to additionally assign to this role. Existing assignments are preserved.
   */
  memberIds?: Array<string> | undefined;
  /**
   * Updated display name.
   */
  name?: string | undefined;
  /**
   * Scope grants to remove.
   */
  removeGrants?: Array<RoleGrant> | undefined;
};

/** @internal */
export type UpdateRoleForm$Outbound = {
  add_grants?: Array<RoleGrant$Outbound> | undefined;
  agent_ids?: Array<string> | undefined;
  description?: string | undefined;
  id: string;
  member_ids?: Array<string> | undefined;
  name?: string | undefined;
  remove_grants?: Array<RoleGrant$Outbound> | undefined;
};

/** @internal */
export const UpdateRoleForm$outboundSchema: z.ZodMiniType<
  UpdateRoleForm$Outbound,
  UpdateRoleForm
> = z.pipe(
  z.object({
    addGrants: z.optional(z.array(RoleGrant$outboundSchema)),
    agentIds: z.optional(z.array(z.string())),
    description: z.optional(z.string()),
    id: z.string(),
    memberIds: z.optional(z.array(z.string())),
    name: z.optional(z.string()),
    removeGrants: z.optional(z.array(RoleGrant$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      addGrants: "add_grants",
      agentIds: "agent_ids",
      memberIds: "member_ids",
      removeGrants: "remove_grants",
    });
  }),
);

export function updateRoleFormToJSON(updateRoleForm: UpdateRoleForm): string {
  return JSON.stringify(UpdateRoleForm$outboundSchema.parse(updateRoleForm));
}
